import { useState } from "react"
import { BookOpen } from "lucide-react"

// Fixed-size cover slot: a missing or broken imageUrl falls back to an icon in
// the same box, so rows keep one height whether the image exists or not.
const BookThumb = ({ src, size = "sm" }) => {
  const [failed, setFailed] = useState(false)
  return (
    <span className={`bi-thumb bi-thumb--${size}`} aria-hidden>
      {src && !failed ? <img src={src} alt="" loading="lazy" onError={() => setFailed(true)} /> : <BookOpen />}
    </span>
  )
}

export default BookThumb
